"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpanderTriggerButton = exports.ClickableRow = exports.CardCol = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _card = require("../card");
var _context = require("../context");
var _helpers = require("../helpers");
var _layout = require("../layout");
var _utils2 = require("../utils");
var _constants = require("./constants");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const CardCol = exports.CardCol = _card.Card.withComponent(_layout.Col, process.env.NODE_ENV === "production" ? {
  target: "edbdntt1"
} : {
  target: "edbdntt1",
  label: "CardCol"
});
const ClickableRow = exports.ClickableRow = /*#__PURE__*/(0, _base.default)(_layout.Row, process.env.NODE_ENV === "production" ? {
  target: "edbdntt0"
} : {
  target: "edbdntt0",
  label: "ClickableRow"
})(process.env.NODE_ENV === "production" ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : {
  name: "e0dnmk",
  styles: "cursor:pointer",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const ExpanderTriggerButton = exports.ExpanderTriggerButton = (0, _context.styledWithTheme)(_helpers.TriggerButton)(_ref => {
  let {
    theme: {
      isInHighContrast
    }
  } = _ref;
  return {
    color: _constants.EXPANDER_HEADER_COLOR,
    ':focus': {
      borderColor: 'transparent',
      color: _constants.EXPANDER_HEADER_COLOR,
      outline: 'none'
    },
    ':hover': {
      color: _constants.EXPANDER_HEADER_COLOR,
      ...(isInHighContrast ? {
        borderColor: _constants.EXPANDER_HEADER_COLOR
      } : {
        backgroundColor: (0, _utils.token)('color.action.utility.bg-hover')
      })
    },
    ':active': {
      color: _constants.EXPANDER_HEADER_COLOR,
      ...(isInHighContrast ? {
        borderColor: _constants.EXPANDER_HEADER_COLOR
      } : {
        backgroundColor: (0, _utils.token)('color.action.utility.bg-pressed')
      })
    },
    ':focus-visible': {
      outline: "".concat((0, _utils2.px)(_constants.FOCUS_OUTLINE_WIDTH), " solid ").concat((0, _utils.token)('color.border.border-focus')),
      outlineOffset: isInHighContrast ? (0, _utils2.px)(_constants.FOCUS_OUTLINE_OFFSET) : "-".concat((0, _utils2.px)(_constants.FOCUS_OUTLINE_WIDTH))
    }
  };
});